module.exports = __webpack_public_path__ + "static/media/A5-Landscape-H1.94c93a79.png";